import React from 'react';

const path = process.env.PUBLIC_URL

const Openning = () => {
  return (
    <div className="h-full openning">
      <div className="h-full relative">
        <img src={`${path}/images/cover.svg`} className="h-[102%] md:h-[95%] object-cover" />
        <img src={`${path}/images/banner.svg`} className="absolute top-[57%] md:top-[55%] h-[18vh] w-full" />
        <img src={`${path}/images/title.svg`} className="absolute top-[20%] left-[50%] h-[40%] translate-x-[-50%]" />
      </div>
    </div>
  );
};

export default Openning;